module.exports = __webpack_public_path__ + "static/media/HRECOS_Stations_Pier_84.c0be97d3.jpg";